<template>
  <div class="activityEdit">
    <div class="activityEditBox">
      <el-row>
        <el-col :span="22">市场活动详情</el-col>
        <el-col :span="2">
          <el-button
            type="info"
            round
            icon="el-icon-back"
            size="small"
            @click="goBack()"
          >
            返 回
          </el-button>
        </el-col>
      </el-row>
      <div class="formBox">
        <el-form
          :model="activity"
          ref="ruleForm"
          label-width="100px"
        >
          <el-form-item label="活动名称:" prop="name">
            <span>{{ activity.name }}</span>
          </el-form-item>

          <el-form-item label="活动上市时间:" prop="start">
            <span>{{ activity.startTime }}</span>
          </el-form-item>

          <el-form-item label="上传截止时间:" prop="end">
            <span>{{ activity.endTime }}</span>
          </el-form-item>

          <el-form-item label="任务类型:" prop="type">
            <span v-if="activity.type==='temp'">临时任务</span>
            <span v-else-if="activity.type==='day'">日任务</span>
            <span v-else-if="activity.type==='week'">周任务</span>
            <span v-else-if="activity.type==='month'">月任务</span>
          </el-form-item>

          <el-form-item label="截止提交:" v-if="activity.type === 'week'" prop="weekSubmitTime">
            <!--            <span v-if="activity.weekStart===0">周日</span>-->
            <!--            <span v-else-if="activity.weekStart===1">周一</span>-->
            <!--            <span v-else-if="activity.weekStart===2">周二</span>-->
            <!--            <span v-else-if="activity.weekStart===3">周三</span>-->
            <!--            <span v-else-if="activity.weekStart===4">周四</span>-->
            <!--            <span v-else-if="activity.weekStart===5">周五</span>-->
            <!--            <span v-else-if="activity.weekStart===6">周六</span>-->
            <!--            至-->
            <span v-if="activity.weekEnd===0">周日</span>
            <span v-else-if="activity.weekEnd===1">周一</span>
            <span v-else-if="activity.weekEnd===2">周二</span>
            <span v-else-if="activity.weekEnd===3">周三</span>
            <span v-else-if="activity.weekEnd===4">周四</span>
            <span v-else-if="activity.weekEnd===5">周五</span>
            <span v-else-if="activity.weekEnd===6">周六</span>
          </el-form-item>

          <el-form-item label="导购可完成:" prop="enableSales">
            <span v-if="activity.enableSales">可完成</span>
            <span v-else>不可完成</span>
          </el-form-item>

          <el-form-item label="适用门店:" prop="end">
            <div class="fileContent">
              <i class="el-icon-download"></i>
              <a @click="exportDoor">适用门店</a>
            </div>
          </el-form-item>

          <div class="attachments">
            <span class="label">附件:</span>
            <ul class="attachmentsContent">
              <li v-for="(attachment, index) in attachmentList" :key="index">
                <i class="el-icon-download"></i>
                <a @click="downLoad(attachment.docUrl, attachment.name)">{{ attachment.name }}</a>
              </li>
            </ul>
          </div>

          <el-form-item label="状态:" prop="status">
            <span v-if="activity.enabled">启用</span>
            <span v-else>未启用</span>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import {downloadFile} from "@/utils/tool";

export default {
  name: "ActivityEdit",
  data() {
    return {
      id: this.$route.query.id || null,
      activity: {},
      file: {},
      attachmentList: [],
    }
  },
  mounted() {
    // todo: 如果有查询id,则根据id去获取数据
    if (this.id) {
      this.getData()
    }
  },
  methods: {
    downLoad(docUrl, name) {
      downloadFile(docUrl, name)
    },
    async getData() {
      let url = "vms/activity/" + this.id;
      let res = await axios.post(url);
      res = res.data
      if (res.code === 200) {
        // 把获取到的数据放到activity里,file,attachmentList
        this.activity = res.data.activity;
        this.attachmentList = res.data.activityFileList;

      }
    },
    goBack() {
      // this.$router.push({path: '/vms/activityManage'});
      this.$router.back();
    },
    async exportDoor() {
      let {data, fileName} = await this.$tool.exportFile({
        method: "post",
        url: vmsReqUrl + "/activity/export/" + this.id,
      });
      console.log(data, fileName);
    }
  }
};
</script>
<style lang="sass" scoped>
.activityEdit
  min-width: 1050px

  .activityEditBox
    padding: 20px

    .formBox
      width: 50%
      margin-left: 25%
      margin-top: 20px

    .fileContent
      color: #67C23A
      cursor: pointer

    .attachments
      display: flex
      margin-bottom: 20px

      .label
        text-align: right
        width: 100px
        vertical-align: middle
        float: left
        font-size: 14px
        color: #606266
        line-height: 36px
        padding: 0 12px 0 0
        -webkit-box-sizing: border-box
        box-sizing: border-box
        flex-shrink: 0

      .attachmentsContent
        line-height: 36px
        width: 100%
        margin: 0
        padding: 0

        li
          list-style: none
          margin: 0
          padding: 0
          font-size: 14px
          color: #67C23A
          cursor: pointer
</style>



// WEBPACK FOOTER //
// src/vms/pages/views/activity/activityDetail.vue